import React from 'react';
import { Consumer } from './scrollContext';
var SectionLink = function SectionLink(_ref) {
  var section = _ref.section,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Consumer, null, function (_ref2) {
    var scrollTo = _ref2.scrollTo,
      selected = _ref2.selected;
    var onClick = function onClick() {
      return scrollTo(section);
    };
    var isSelected = selected === section;
    return children({
      onClick: onClick,
      isSelected: isSelected
    });
  });
};
export default SectionLink;